import React from 'react';
const WhatsappSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      className={className}
      {...props}
    >
      <rect width='27.9964' height='28' rx='13.9982' fill='black' />
      <path
        d='M19.9888 10.2374C17.8888 6.99989 13.6012 6.03739 10.2762 8.0499C7.03869 10.0624 5.98868 14.4374 8.08869 17.675L8.2637 17.9375L7.56369 20.5625L10.1887 19.8625L10.4512 20.0375C11.5887 20.65 12.8137 21 14.0387 21C15.3513 21 16.6638 20.65 17.8013 19.95C21.0388 17.85 22.0013 13.5624 19.9888 10.2374ZM18.1513 16.975C17.8013 17.5 17.3638 17.85 16.7513 17.9375C16.4013 17.9375 15.9638 18.1125 14.2137 17.4125C12.7262 16.7125 11.5012 15.575 10.6262 14.2624C10.1012 13.6499 9.83871 12.8624 9.75121 12.0749C9.75121 11.3749 10.0137 10.7624 10.4512 10.3249C10.6262 10.1499 10.8012 10.0624 10.9762 10.0624H11.4137C11.5887 10.0624 11.7637 10.0624 11.8512 10.4124C12.0262 10.8499 12.4637 11.8999 12.4637 11.9874C12.5512 12.0749 12.5512 12.2499 12.4637 12.3374C12.5512 12.5124 12.4637 12.6874 12.3762 12.7749C12.2887 12.8624 12.2012 13.0374 12.1137 13.1249C11.9387 13.2124 11.8512 13.3874 11.9387 13.5624C12.2887 14.0874 12.7262 14.6125 13.1637 15.05C13.6887 15.4875 14.2137 15.8375 14.8262 16.1C15.0012 16.1875 15.1762 16.1875 15.2637 16.0125C15.3512 15.8375 15.7888 15.4 15.9638 15.225C16.1388 15.05 16.2263 15.05 16.4013 15.1375L17.8013 15.8375C17.9763 15.925 18.1513 16.0125 18.2388 16.1C18.3263 16.3625 18.3263 16.7125 18.1513 16.975Z'
        fill='white'
      />
    </svg>
  );
};

export default WhatsappSVG;
